export default __webpack_public_path__ + "static/media/Screen3.610eb271.gif";